<template>
  <div>
    <el-dialog title="检查报告单" :visible.sync="dialogVisible" width="700px">
      <div
        class="doctorReportDetails scrollbar"
        :style="{ height: height - 183 + 'px' }"
      >
        <div class="nav">
          <!-- <div class="blueText">
            检查报告单
          </div> -->
          <div class="navexplain">
            <span class="navexplaintext color-white">
              编号: {{ reportDetails.AccNo }}
            </span>
            <span class="navexplaintext color-white">
              机构名称: {{ reportDetails.HospitalName }}
            </span>
          </div>
        </div>
        <!-- nav -->
        <div class="content" :style="{ height: height - 280 + 'px' }">
          <div class="content-wrap">
            <div class="manifestation">
              <svg-icon class="fz18 marr5" icon-class="report-user"></svg-icon>
              就诊人信息
            </div>
            <div class="manifestationP">
              <el-row>
                <el-col :span="8">
                  <span
                    >就诊人编号:
                    {{ reportDetails.PatientNo | globalFilter }}</span
                  >
                </el-col>
                <el-col :span="8">
                  <span>
                    检查日期:
                    <!-- {{ reportDetails.ExaminDate.substr(0, 10) }} -->
                    {{ reportDetails.ExaminDate || "--" }}
                  </span>
                </el-col>
                <el-col :span="8">
                  <span>
                    模态:
                    {{ reportDetails.ModalityType || "--" }}
                  </span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <span
                    >姓名: {{ reportDetails.PatientName | globalFilter }}</span
                  >
                </el-col>
                <el-col :span="8">
                  <span>性别: {{ reportDetails.Gender | globalFilter }}</span>
                </el-col>
                <el-col :span="8">
                  <span
                    >年龄: {{ reportDetails.CurrentAge | globalFilter }}</span
                  >
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <span
                    >科室: {{ reportDetails.ApplyAdpt | globalFilter }}</span
                  >
                </el-col>
                <el-col :span="8">
                  <span
                    >住院号:
                    {{ reportDetails.InhospitalNo | globalFilter }}</span
                  >
                </el-col>
                <el-col :span="8">
                  <span>床号: {{ reportDetails.BedNo | globalFilter }}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <span>
                    检查部位:
                    {{ reportDetails.BodyParts | globalFilter }}</span
                  >
                </el-col>
                <el-col :span="8">
                  <span>
                    扫描类型:
                    {{ reportDetails.ScanTypes | globalFilter }}
                  </span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <span
                    >检查项目:
                    {{ reportDetails.CheckingItems | globalFilter }}</span
                  >
                </el-col>
              </el-row>
            </div>
            <div class="dividingLine"></div>
          </div>
          <div class="content-wrap">
            <div class="manifestation">
              <svg-icon
                class="fz18 marr5"
                icon-class="report-history"
              ></svg-icon>
              病史
            </div>
            <p class="manifestationP" v-html="reportDetails.HealthHistory"></p>
            <div class="dividingLine"></div>
          </div>

          <div class="content-wrap">
            <div class="manifestation">
              <svg-icon class="fz18 marr5" icon-class="report-wys"></svg-icon>
              影像学表现
            </div>
            <p class="manifestationP" v-html="reportDetails.WysText"></p>
            <div class="dividingLine"></div>
          </div>

          <div class="content-wrap">
            <div class="manifestation">
              <svg-icon class="fz18 marr5" icon-class="report-wyg"></svg-icon>
              影像学诊断
            </div>
            <p class="manifestationP" v-html="reportDetails.WygText"></p>
            <div class="dividingLine"></div>
          </div>

          <div class="content-wrap">
            <div class="manifestation">
              <svg-icon
                class="fz18 marr5"
                icon-class="report-isrelative"
              ></svg-icon>
              阴阳性
            </div>
            <p class="manifestationP">
              {{ reportDetails.IsPositive || "--" }}
            </p>
            <div class="dividingLine"></div>
          </div>
        </div>
        <div class="bottom">
          <el-row>
            <el-col :span="6" class="color-white">
              报告医师: {{ reportDetails.ReportSubmitterName }}
            </el-col>
            <el-col :span="6" class="color-white">
              审核医师: {{ reportDetails.FirstApproverName }}
            </el-col>
            <el-col :span="6" class="color-white">
              审核时间: {{ (reportDetails.FirstApproveDt && reportDetails.FirstApproveDt.substr(0, 10)) || '--' }}
            </el-col>
            <el-col :span="6" class="color-white">
              报告时间: {{ (reportDetails.ReportSubmitDt && reportDetails.ReportSubmitDt.substr(0, 10)) || '--' }}
            </el-col>
          </el-row>
        </div>
      </div>
      <template #footer>
        <div class="footer" style="text-align: center">
          <el-button type="primary" @click="dialogVisible = false">
            关闭
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import oldAxios from "@/js/api";
import Api from "../../../api";
// import { mapState, mapActions, mapMutations} from 'vuex'
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    reportId: {
      type: String,
      default: "",
    },
    hospCode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      height: `${document.documentElement.clientHeight}`,
      reportDetails: {},
    };
  },
  watch: {
    reportId: {
      handler(newVal) {
        console.log(newVal, "vallllll");
        if (newVal) {
          this.getReportDetails();
        }
      },
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  filters: {
    globalFilter: function(val) {
      if (val == null || val == "" || val == undefined) {
        return "-";
      } else {
        return val;
      }
    },
  },
  methods: {
    getReportDetails() {
      oldAxios
        .ajaxGet("get", Api.api.manager.GetReportDetailsByHand, {
          reportId: this.reportId,
        })
        .then((res) => {
          if (res.data.StatusCode === 200) {
            this.reportDetails = res.data.Data;
          }
          console.log(res, "获取手动上传报告详情");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.color-white {
  color: #fff;
}
.doctorReportDetails {
  .nav {
  }
}
.el-dialog__footer {
  padding: 10px;
}
</style>
